export enum GeometryType {
    LineString = "LineString",
    Polygon = "Polygon",
    Point = "Point"
}